'use strict';

var $ = require('jquery');

$(function() {
  
   // navigation on scroll
   navigationOnScroll();
     $(window).scroll(function(){
          navigationOnScroll()
     });
     function navigationOnScroll(){
          if($('#nav').length > 0){
               if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                    $('.nav-wrapp').addClass('nav-shrink');
                    $('.main-nav').addClass('shrink');
                    $('.mobile-navigation').addClass('shrink-mobile');
                    $('.nav-container .logo').addClass('shrink-logo');
               }else{
                    $('.nav-wrapp').removeClass('nav-shrink');
                    $('.main-nav').removeClass('shrink');
                    $('.mobile-navigation').removeClass('shrink-mobile');
                    $('.nav-container .logo').removeClass('shrink-logo');
               } 
          } 
     };
     $('.hamburger').click(function(){
          $('.hamburger').toggleClass('is-active');
          $('.mobile-navigation').toggleClass('open');
          $('.main-nav').toggleClass('menu-open');
          if ($('.mobile-navigation').hasClass('open') ) {
          }else{
          }
      });
      function addParentClassActive(){
          if($('.child-has-active').hasClass( "active" )) {
               $('.child-has-active').parent().parent().prev().addClass('active');
          }
     }
     addParentClassActive();

     function countheight(){
          var elemh = $('.notification-area').height();
          $('.main-nav').css( "top", elemh);
          $('.overlay-nav').css( "top", elemh);
          $('.spacetaker').css( "height", elemh);
     }
     if($('.notification-area').length > 0){
          countheight();
     }
	$( window ).resize(function() {
          if($('.notification-area').length > 0){
               countheight();
          }
	});
});